export function DnaSequence({ compact = false }) {
  return (
    <div className={`dna-sequence ${compact ? "is-compact" : ""}`} aria-hidden="true" data-testid="dna-sequence-graphic">
      {Array.from({ length: 14 }, (_, index) => (
        <span className="dna-pair" style={{ "--i": index }} key={index}>
          <i className="dna-node dna-node-left" />
          <i className="dna-bond" />
          <i className="dna-node dna-node-right" />
        </span>
      ))}
    </div>
  );
}
